module.exports = __webpack_public_path__ + "static/AngelaFan-733e6d8f4d39b941986c6d5301fa7a1a.png";